import { render, staticRenderFns } from "./sysStudentDo.vue?vue&type=template&id=3bdc0c06&"
import script from "./sysStudentDo.vue?vue&type=script&lang=js&"
export * from "./sysStudentDo.vue?vue&type=script&lang=js&"
import style0 from "./sysStudentDo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports